<template>
  <header
    :class="[
      'header',
      {'header--screen': $nuxt.$breakpoints.sLg && isNavOpened}
    ]"
  >
    <div class="header__wrapper">
      <header-aside></header-aside>
      <header-main
        :menu="menuGroupingByServices[$i18n.locale]"
        :on-toggle="toggleNav"
      ></header-main>
    </div>
  </header>
</template>

<script>
import {menuGroupingByServices} from '~/helpers/enum/menuGroupingByServices'

import HeaderAside from '~/components/header/HeaderAside'
import HeaderMain from '~/components/header/HeaderMain'

export default {
  name: 'AppHeader',
  components: {
    HeaderAside,
    HeaderMain
  },
  data() {
    return {
      menuGroupingByServices,

      isNavOpened: false
    }
  },
  methods: {
    toggleNav(isNavOpened) {
      this.isNavOpened = isNavOpened
    }
  }
}
</script>

<style lang="scss">
.header {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100vw;

  &.header--screen {
    right: auto;
    width: 100%;
    height: 100%;
    display: flex;
  }
}

.header__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: $breakpoint-xl) {
    height: auto;
    max-height: 100%;
    overflow: auto;
  }

  &--screen {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: stretch;
  }
}

.header--white {
  border-bottom: 1px solid $primaryBorder;
  background-color: #FFFFFF;
  color: $primary;

  .header__container--top {
    background-color: transparentize($primary10, 0.5);
  }

  .header__white-logo {
    display: none;
  }

  .header__color-logo {
    display: block;
  }
}
</style>